import { render, staticRenderFns } from "./CaseStudyCard.vue?vue&type=template&id=fef48fc2&scoped=true"
import script from "./CaseStudyCard.vue?vue&type=script&lang=ts"
export * from "./CaseStudyCard.vue?vue&type=script&lang=ts"
import style0 from "./CaseStudyCard.vue?vue&type=style&index=0&id=fef48fc2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef48fc2",
  null
  
)

export default component.exports